import React from "react";

import { Modal } from "components/Sundry/Table/Modal";

import { ModalTypes } from "constants/navigation";

import { useHasManualChargesPermission, useModalAdapter } from "hooks";

export const Adapter = props => {
  const [_ignored, returnTo, onClose] = useModalAdapter(
    ModalTypes.ManualAdjustmentTable,
    props,
  );

  const hasManualChargePermission = useHasManualChargesPermission();

  if (hasManualChargePermission) {
    return <Modal returnTo={returnTo} onClose={onClose} />;
  }
};
